module.exports = __webpack_public_path__ + "static/media/47.ae41e4b4.gif";